var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8125 5.25C11.088 5.25 10.5 5.838 10.5 6.5625C10.5 7.28831 11.088 7.875 11.8125 7.875C12.537 7.875 13.125 7.28831 13.125 6.5625C13.125 5.838 12.537 5.25 11.8125 5.25ZM17.0625 5.25C16.338 5.25 15.75 5.838 15.75 6.5625C15.75 7.28831 16.338 7.875 17.0625 7.875C17.787 7.875 18.375 7.28831 18.375 6.5625C18.375 5.838 17.787 5.25 17.0625 5.25ZM45.375 10.5H2.625V5.25C2.625 3.801 3.801 2.625 5.25 2.625H42.75C44.199 2.625 45.375 3.801 45.375 5.25V10.5ZM45.375 32.55C45.375 33.999 44.199 35.175 42.75 35.175H5.25C3.801 35.175 2.625 33.999 2.625 32.55V13.125H45.375V32.55ZM42.75 0H5.25C2.35069 0 0 2.35069 0 5.25V32.55C0 35.4493 2.35069 37.8 5.25 37.8H42.75C45.6493 37.8 48 35.4493 48 32.55V5.25C48 2.35069 45.6493 0 42.75 0ZM6.5625 5.25C5.838 5.25 5.25 5.838 5.25 6.5625C5.25 7.28831 5.838 7.875 6.5625 7.875C7.287 7.875 7.875 7.28831 7.875 6.5625C7.875 5.838 7.287 5.25 6.5625 5.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.2e6b717164e433a2e479060d98a3af44.svg";
export { ForwardRef as ReactComponent };